"use client";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, Col, Row, Select } from "antd";
import PulseDateRange from "components/Common/DateRangeComponents/PulseDateRange";
import { setPageLoader } from "reducers/loaderSlice";
import { CompareIcon, NegativeIcon, NeutralIcon, PositiveIcon, ReviewIcon } from "../icon";

const CompanyCompareFilter = ({
  filterValue,
  setFilterValue,
  onFilterChange,
  onCompareClick,
  companyReviewData,
  companiesList,
  companiesLoading,
  loadingStates,
  reviewCounts,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageLoader(companiesLoading ? "refresh" : null));
  }, [dispatch, companiesLoading]);

  useEffect(() => {
    if (companiesList?.companies?.length > 0) {
      const firstCompany = companiesList.companies[0];
      const secondCompany =
        companiesList.companies[1] || companiesList.companies[0];

      setFilterValue({
        companies: [
          {
            company: firstCompany.company,
            minDate: firstCompany.min_date * 1000,
            maxDate: firstCompany.max_date * 1000,
            startDate: firstCompany.min_date * 1000,
            endDate: firstCompany.max_date * 1000,
            bikeModel: null,
          },
          {
            company: secondCompany.company,
            minDate: secondCompany.min_date * 1000,
            maxDate: secondCompany.max_date * 1000,
            startDate: secondCompany.min_date * 1000,
            endDate: secondCompany.max_date * 1000,
            bikeModel: null,
          },
        ],
        sourceList: null,
        sentiment: null,
      });
    }
  }, [companiesList, setFilterValue]);

  const getCompanyOptions = () => {
    if (!companiesList?.companies) return [];
    return companiesList.companies;
  };


const handleCompanyChange = (index, companyName) => {
  const companyData = companiesList.companies.find(
    (c) => c.company === companyName
  );
  if (!companyData) return;

  setFilterValue((prev) => {
    const updatedCompanies = prev.companies.map((company, i) =>
      i === index ? {
            company: companyName,
            minDate: companyData.min_date * 1000,
            maxDate: companyData.max_date * 1000,
            startDate: companyData.min_date * 1000,
            endDate: companyData.max_date * 1000,
            bikeModel: null,
          }: company
    );

    return {
      ...prev,
      companies: updatedCompanies,
    };
  });
};


  const renderCompanySection = (index) => {
    const company = filterValue.companies?.[index];
    const reviewData = companyReviewData?.[index];
    const isLoading = loadingStates?.[index];

    if (!company) return null;

    return (
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Row gutter={[16, 16]} justify={index === 1 ? "end" : "start"}>
          <Col xs={24} sm={24} md={24} lg={24} xl={12}>
            <div className="filter-heading">Company {index + 1}</div>
            <Select
              showSearch
              size="large"
              placeholder="Select a company"
              className="w100"
              value={company.company}
              loading={companiesLoading}
              options={getCompanyOptions()}
              fieldNames={{
                label: "company",
                value: "company",
              }}
              onChange={(value) => handleCompanyChange(index, value)}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={12}>
            <div className="filter-heading">Date</div>
            <PulseDateRange
              dataTimeRange={[company.minDate, company.maxDate]}
              selectedTimeRange={[company.startDate, company.endDate]}
              onTimeFilterChange={(value) =>
                onFilterChange("dates", index, value)
              }
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: "16px" }} justify={index === 1 ? "end" : "start"}>
          <Col xs={24} sm={24} md={24} lg={24} xl={12}>
            <div className="filter-heading">Bike Model</div>
            <Select
              allowClear
              size="large"
              mode="multiple"
              placeholder="Select a Model"
              className="w100"
              value={company.bikeModel || [null]}
              loading={isLoading}
              maxTagCount="responsive"
              onChange={(value) =>
                onFilterChange(
                  "bikeModel",
                  index,
                  value,
                  reviewData?.bike_models?.length
                )
              }
            >
              <Select.Option value={null}>All</Select.Option>
              {reviewData?.bike_models?.map((item, idx) => (
                <Select.Option key={idx} value={item}>
                  {item}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={12}>
            <div className="filter-heading">
              {/* Reviews - {reviewData?.total_reviews || 0} */}
              Reviews Sentiment
            </div>
            <div className="comparison-container">
              <div className="likes-box-base comparison-likes-box">
                <PositiveIcon className="comparison-review-type-icon positive-review-icon" />
                <div>
                  <div className="comparison-review-percentage-text">
                    {(reviewData?.positive_percentage || 0).toFixed(2)}%
                  </div>
                </div>
              </div>
              <div className="dislikes-box-base comparison-dislikes-box">
              <NegativeIcon className="comparison-review-type-icon negative-review-icon" />
              <div>
                  <div className="comparison-review-percentage-text">
                    {(reviewData?.negative_percentage || 0).toFixed(2)}%
                  </div>
                </div>
              </div>
              <div className="neutral-box-base comparison-neutral-box">
              <NeutralIcon className="comparison-review-type-icon neutral-review-icon" />
              <div>
                  <div className="comparison-review-percentage-text">
                    {(
                      100 -
                      ((reviewData?.positive_percentage || 0) +
                        (reviewData?.negative_percentage || 0))
                    ).toFixed(2)}
                    %
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    );
  };

  return (
    <Card bordered={false} className="filter-box marketpulse-subheader-card">
      <Row gutter={[24, 24]}>
        {renderCompanySection(0)}
        {renderCompanySection(1)}

        <Col xs={24}>
          <Row justify="center">
            <Col>
              <Button
                data-testid="confirm"
                type="primary"
                className="comparison-compare-button"
                htmlType="submit"
                onClick={onCompareClick}
              >
                <CompareIcon />
                Compare
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default CompanyCompareFilter;